import { TRIANGLE_SYMBOL_CLASS_NAME } from './constants';

/**
 * Wrap R to span.
 * @param {string} text.
 * @return {string}
 */
// The value of ® is AE. It would replace only if ® not starts with <sup>
const regexpTrademark = new RegExp(/(?:[\xAE])(?!<\/sup>)/, 'gi');
const regexpTriangleGlobal = new RegExp(
  `▼(?![^<]*<\\/span>)(?![^<]*class=["']${TRIANGLE_SYMBOL_CLASS_NAME}["'])`,
  'gi',
);

const prepText = (text: string): string => {
  return !!text ? text.replace(regexpTrademark, '<sup>$&</sup>') : '';
};

const prepTriangle = (text: string): string => {
  return !!text
    ? text.replace(regexpTriangleGlobal, `<span class="${TRIANGLE_SYMBOL_CLASS_NAME}">$&</span>`)
    : '';
};

const removeHTML = (input: string): string => {
  return input.replace(/<\/?[^>]+(>|$)/g, '');
};

export { regexpTrademark, regexpTriangleGlobal, prepTriangle, removeHTML };
export default prepText;
